// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CriteriaFilter, CriteriaFilterSchema } from 'api/gen/CriteriaFilter';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';

// Male filter settings with ids exposed as organizationIds.

const requiredPart = t.interface({
  filters: t.array(CriteriaFilterSchema),
  organizationIds: t.union([t.array(PositiveIntegerSchema), t.null]),
});

export const MaleCriteriaFiltersSchema = excess(requiredPart);

export interface MaleCriteriaFilters extends t.TypeOf<typeof MaleCriteriaFiltersSchema> {}
